import React from 'react';

export default function Footer() {
    return(
            <div class="footer-padding">
                <div class="footer">
                    <p>A Rishikesh Sarangan Website</p>
                </div>
            </div>
    )
}